import { CreateIncidendContext } from "@/contexts"
import { useContext } from "react"

export const useCreateIncidentContext = () => {
  const context = useContext(CreateIncidendContext)

  if (!context) throw new Error('useCreateIncidentContext hook have to wrapped by CreateIncidentContextProvider')

  return context
}
